import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCashierLimits = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3189_4965)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M18.6863 12.6245C18.8213 13.9064 18.6472 15.2328 18.1138 16.4857V16.4862L19.9655 18.8777C20.1312 19.0918 20.442 19.1212 20.6472 18.9446C22.31 17.5137 23.4102 15.4482 23.5732 13.124C23.5922 12.8534 23.3745 12.6246 23.1032 12.6246H18.6863V12.6245Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.0371 0.471001V6.31882C15.6059 6.99774 16.9082 8.17997 17.7396 9.66023H23.1156C23.3814 9.66023 23.5965 9.44022 23.5862 9.17458C23.3948 4.20338 19.4313 0.249292 14.5279 0.000605083C14.2604 -0.0129545 14.0371 0.203152 14.0371 0.471001Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.0415 21.2236C6.76145 21.2678 3.22442 17.7977 3.18981 13.5175C3.15492 9.20384 6.6542 5.68314 10.96 5.68314V3.38973C10.96 3.12137 10.7359 2.90667 10.4678 2.91896C4.87219 3.17603 0.413621 7.79406 0.413574 13.4536C0.413574 19.2894 5.19353 24.0373 11.0292 23.9998C13.23 23.9856 15.2701 23.2977 16.9542 22.132C17.1758 21.9787 17.2224 21.6701 17.0574 21.457L15.653 19.643C14.3682 20.6192 12.7719 21.2057 11.0415 21.2236Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.60205 13.4537C4.60205 16.9594 7.45428 19.8116 10.96 19.8116C14.4654 19.8116 17.318 16.9599 17.318 13.4537C17.318 9.94802 14.4654 7.0957 10.96 7.0957C7.45428 7.0957 4.60205 9.94793 4.60205 13.4537ZM11.6662 9.22993V9.90367C12.3903 9.90367 13.0312 10.2116 13.4831 10.6937C13.7496 10.9781 13.735 11.4254 13.4506 11.6918C13.168 11.9566 12.7229 11.9465 12.4525 11.6594C12.25 11.4437 11.9741 11.3185 11.695 11.3161C11.1235 11.3161 10.7372 11.3161 10.1681 11.3161C9.77227 11.3161 9.45244 11.6368 9.45244 12.0318C9.45244 12.4263 9.77354 12.7474 10.1686 12.7474H11.7519C12.9252 12.7474 13.88 13.7022 13.88 14.8755C13.88 15.9719 13.0367 17.0041 11.6662 17.0041V17.6774C11.6662 18.0672 11.3503 18.3836 10.96 18.3836C10.5702 18.3836 10.2538 18.0672 10.2538 17.6774V17.0041C9.75631 17.0041 9.26618 16.9502 8.69206 16.5521C8.37191 16.3299 8.29234 15.8897 8.51456 15.5695C8.73679 15.2489 9.17701 15.1693 9.49717 15.3916C9.66666 15.5102 9.87716 15.5889 10.0866 15.5916H11.7519C12.1452 15.5916 12.4676 15.2741 12.4676 14.8755C12.4676 14.481 12.1465 14.1599 11.7519 14.1599C11.0512 14.1599 10.9068 14.1599 10.1686 14.1599C8.9948 14.1599 8.03998 13.2051 8.03998 12.0318C8.03998 10.932 8.88628 9.90367 10.2538 9.90367V9.22993C10.2538 8.84009 10.5702 8.5237 10.96 8.5237C11.3503 8.5237 11.6662 8.84009 11.6662 9.22993Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3189_4965",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}) })]
});
export default SvgCashierLimits;
